import styled from 'styled-components';

export const Wrapper = styled.div`
    height: calc(100% - 60px);
    padding: 5px;
`;

export const CargoTankTemperaturesWrapper = styled.div`
    margin: 0 0 0 -5px;
`;

export const GridWrapper = styled.ul`
    li {
        display: grid;
        grid-template-columns: 1fr 1.5fr 0.6fr 0.5fr 1fr 1fr;

        > label,
        > span {
            max-width: 100%;
        }
        .input-unit {
            width: unset !important;
        }
        .centered-text {
            text-align: center;
        }
        .centered-checkbox label .input-value-wrapper .input-value,
        .centered-checkbox .input-value-wrapper,
        .temperature-input .input-value-wrapper {
            text-align: center;
            justify-content: center;
        }
        .temperature-input input {
            width: 40px;
        }
        .col-trade-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .external-link-icon {
            margin-left: 4px;
            color: steelblue;
        }
    }
`;
